import { MetaData } from '@shared/interfaces/metaFlight';
import { parseQuery } from '@libs/utils/url/url';
import { isUsingFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

function getBookingTokenUrlParam(): string {
    const kebabCaseBookingToken = urlParams.get('booking-token');
    const pascalCaseBookingToken = urlParams.get('BookingToken');
    const camelCaseBookingToken = urlParams.get('bookingToken');

    if (kebabCaseBookingToken !== null) {
        return kebabCaseBookingToken;
    } else if (pascalCaseBookingToken !== null) {
        return pascalCaseBookingToken;
    } else if (camelCaseBookingToken !== null) {
        return camelCaseBookingToken;
    }
    return '';
}

export function getBookingUrlParams(): {
    bookingId: string;
    password: string;
    token: string;
} {
    const token = getBookingTokenUrlParam();

    if (token) {
        const [bookingId, password] = token.split(/[-|]/);
        return {
            bookingId,
            password,
            token,
        };
    }
    const bookingId = urlParams.get('boknid') ?? '';
    const password = urlParams.get('id') ?? '';

    return {
        bookingId,
        password,
        token: bookingId && password ? `${bookingId}|${password}` : '',
    };
}

export function getShoppingCartUrlParam() {
    return urlParams.get('shoppingCartKey') ?? '';
}

export function getMetaDataFromQuery(): MetaData {
    const query = parseQuery(window.location.search);
    const [identifier = ''] = isUsingFakeData() ? ['fake Id'] : (query.identifier ?? '');
    const [utm_source = ''] = isUsingFakeData() ? ['Momondo test'] : (query.utm_source ?? '');
    return {
        Affiliate: utm_source,
        FlightIdentifierId: identifier,
    };
}

export function getFakeBookingId() {
    const bookingId = getBookingUrlParams().bookingId;
    return bookingId ? bookingId : '0000123';
}

export function getFakeBookingNumber() {
    const bookingId = getFakeBookingId();
    return bookingId.split('').reverse().join('');
}

export function getFakePassword() {
    const password = getBookingUrlParams().password;
    return password ? password : '123FAKE';
}

export function getFakeBookingToken() {
    const token = getBookingUrlParams().token;
    return token ? token : '0000123-123FAKE';
}
